interface ToneSliderProps {
  value: 1 | 2 | 3 | 4 | 5;
  onChange: (value: 1 | 2 | 3 | 4 | 5) => void;
}

const LABELS = ['Light', 'Gentle', 'Balanced', 'Dark', 'Bleak'] as const;

export function ToneSlider({ value, onChange }: ToneSliderProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{LABELS[0]}</span>
        <span>{LABELS[4]}</span>
      </div>
      <input
        type="range"
        min={1}
        max={5}
        step={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value) as 1 | 2 | 3 | 4 | 5)}
        className="w-full h-2 bg-card border border-border rounded-full appearance-none cursor-pointer accent-primary [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-primary [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-primary-foreground [&::-webkit-slider-thumb]:shadow-sm"
        aria-label="Tone darkness"
        aria-valuetext={LABELS[value - 1]}
      />
      <div className="flex justify-between px-0.5">
        {LABELS.map((label, i) => (
          <span
            key={label}
            className={[
              'text-xs transition-colors',
              i + 1 === value ? 'text-foreground font-medium' : 'text-muted-foreground/60',
            ].join(' ')}
          >
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
